import React from 'react';
import NodeKPQuestionPageFull from './Full';
import NodeKPQuestionPageTeaser from './Teaser';

const NodeKPQuestionPage = (props) => {
  const { viewMode } = props;
  switch (viewMode) {
    case 'teaser':
      return <NodeKPQuestionPageTeaser {...props} />;

    default:
      return <NodeKPQuestionPageFull {...props} />;
  }
};

export default NodeKPQuestionPage;
